<template>
    <div class="book-header" style="margin-bottom: 15px;text-align: center;">
      <h1 style="font-size: 25px;"><router-link :to="`/book/${id}`"><i class="el-icon-reading"></i>  {{ title }}</router-link></h1>
      <div class="book-meta" style="display: flex;gap: 10px;">
        <img :src="bookCover" :alt="title + ' cover'" class="book-cover" loading="lazy">
        <div style="display: block;">
          <!-- <h3 style="color: #ffffffe5;">{{ authorName }}</h3> -->
          <BookTags :tags="tags" />
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  import BookTags from './BookTags.vue'

  export default {
    name: 'BookHeader',
    components: {
    BookTags
    },
    props: {
      id : Number,  
      title: String,
      bookCover: String,
      authorName: String,
      tags: Array
    }
  }
  </script>

  <style scoped>
    a:link, a:visited {
    background-color: #fffffff0;
    color: black;
    border: 2px solid #d39f52;
    padding: 2px 4px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin-bottom: 10px;
    width: 98%;
    margin-top: 5px;
    border-radius: 10px;
  }
  
  a:hover, a:active {
    background-color: #d39f52;
    color: white;
  }
    </style>